var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 40C2 39.4477 2.44772 39 3 39H45C45.5523 39 46 39.4477 46 40C46 40.5523 45.5523 41 45 41H3C2.44772 41 2 40.5523 2 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 8H10C7.79086 8 6 9.79086 6 12V30C6 32.2091 7.79086 34 10 34H38C40.2091 34 42 32.2091 42 30V12C42 9.79086 40.2091 8 38 8ZM10 6C6.68629 6 4 8.68629 4 12V30C4 33.3137 6.68629 36 10 36H38C41.3137 36 44 33.3137 44 30V12C44 8.68629 41.3137 6 38 6H10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.48f09085675ce5675ed84b4bb598ed80.svg";
export { ForwardRef as ReactComponent };